// @flow

import * as React from 'react'
import { Divider, Label, Icon } from 'semantic-ui-react'
import EditableButton from './editable-button'

import type { Wave as WaveType, WaveSummary } from '../store/campaigns.js'

type WaveProps = {|
  onDropWave: (name: string) => void,
  name: string,
  last: boolean,
  isAdmin: boolean,
  visitsLastWave: number,
|}

const Wave = (props: WaveProps) => {
  function dropWaveHandler() {
    if (typeof props.onDropWave === 'function') {
      props.onDropWave(props.name)
    }
  }
  return (
    <Label style={{ margin: '1ex' }} color={props.last ? 'red' : undefined}>
      {props.name}
      {props.last && props.visitsLastWave === 0 && props.isAdmin && <Icon name="delete" onClick={dropWaveHandler} />}
    </Label>
  )
}

type WaveSectionProps = {|
  waves: Array<WaveType>,
  waveSummary: WaveSummary,
  campaignName: string,
  isAdmin: boolean,
  onDropWave: (name: string) => void,
  onAddWave: (name: string) => void,
|}

const WavesSection = (props: WaveSectionProps) => {
  let waves = []
  for (let i = 0; i < props.waves.length; i++) {
    waves.push(
      <Wave
        name={props.waves[i].name}
        key={'wave-' + i}
        last={props.waveSummary.last_wave === props.waves[i].name}
        visitsLastWave={props.waveSummary.visits_last_wave}
        isAdmin={props.isAdmin}
        onDropWave={props.onDropWave}
      />
    )
  }
  if (props.isAdmin || waves.length > 0) {
    return (
      <div className="column">
        <Divider horizontal>Wave Presenti</Divider>
        {waves.length > 0 ? waves : 'Nessuna wave associata alla campagna'}
        {props.isAdmin && (
          <div>
            <EditableButton onCommit={props.onAddWave} />
          </div>
        )}
      </div>
    )
  } else {
    return <span style={{ display: 'none' }} />
  }
}

export default WavesSection



// WEBPACK FOOTER //
// ./src/campaigns/waves-section.js